<div class="qpp-row flexible centered">
  <img [src]="logoDark" />
</div>
<div class="app-row login-error" [class.hidden]="!hasError">
  <span class="error-message" [innerHTML]="errorMessage"></span>
</div>
<div class="form-group" >
  <div class="form-control-label">Username(email)</div>
  <input class="form-control" type="email" [(ngModel)]="identity" >
</div>
<div class="form-group" >
  <div class="form-control-label">Password</div>
  <input class="form-control" #pw_input type="password" (keyup)="password=$any($event.target).value">
</div>
